export const state = () => ({
  list: [],
  count: 0
})

export const mutations = {
  set: (state, [key, value]) => (state[key] = value),
  removeListItem(state, payload) {
    const f = state.list.findIndex((item) => item.id === payload.id)

    if (f !== -1) {
      state.list = [...state.list.slice(0, f), ...state.list.slice(f + 1)]
    }
  }
}

export const actions = {
  fetch({ commit }, payload) {
    return this.$api
      .get("/request/list", {
        params: payload
      })
      .then((res) => {
        if (res && res.data) {
          commit("set", ["list", res.data.results || []])
          commit("set", ["count", res.data.items_count || 0])
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },

  deleteItemAction({ commit }, payload) {
    return this.$api
      .delete("/request/delete/" + payload.id)
      .then(() => {
        commit("removeListItem", payload)
      })
      .catch((err) => {
        console.log(err)
      })
  }
}
